export const OrderCategoryEnum = {
  PROMOTIONAL: 'promocional',
  AMOSTRA_GRATIS: 'amostra_gratis',
  AMOSTRA_GRATIS_TRIBUTADA: 'amostra_gratis_tributada',
};